/**
 * Format a number as currency for display.
 * Used by order count lines and other price summaries.
 */
export function formatMoney(value, currencyCode = 'USD') {
    const amount = typeof value === 'number' ? value : parseFloat(value);
    try {
        return amount.toLocaleString('en', {
            style: 'currency',
            currency: currencyCode,
        });
    }
    catch {
        return amount.toLocaleString('en', { style: 'currency', currency: 'USD' });
    }
}
export function round2dp(value) {
    return Number(value.toFixed(2));
}
